<!-- Header Section -->
<div class="sidenav-header">
    <button mat-icon-button (click)="loadAccounts()" [disabled]="refreshing" matTooltip="Refresh sessions">
        @if (refreshing) {
        <mat-spinner diameter="18"></mat-spinner>
        } @else {
        <mat-icon>refresh</mat-icon>
        }
    </button>
    <h2 class="sidenav-title">
        @if (type == 'stock') {
        Stocks
        }
        @else if (type == 'customer') {
        Customers
        }
    </h2>

    <span class="spacer"></span>

    <button mat-icon-button (click)="openCreateLogin()" matTooltip="Add new account session">
        <mat-icon>add</mat-icon>
    </button>
</div>

@if (loading) {
<!-- Loading State -->
<div class="loading-container">
    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
    <p class="loading-text">Loading accounts...</p>
</div>
}
@else if (accounts.length === 0) {
<!-- Empty State -->
<div class="empty-state">
    <mat-icon class="empty-icon">account_circle</mat-icon>
    <h3>No Active Sessions</h3>
    <p>No account sessions found</p>
    <button mat-raised-button color="primary" (click)="loadAccounts()">
        <mat-icon>refresh</mat-icon>
        Retry
    </button>
</div>
}
@else {
<mat-nav-list class="accounts-list">
    @for (account of accounts; track account.id) {
    <div class="account-list-item" [class.account-error]="account.error_message"
        [class.account-success]="!account.error_message && account.status === 'in_app' && !account.has_active_transfers"
        [class.account-progress]="!account.error_message && account.status !== 'in_app'"
        [class.account-in-use]="!account.error_message && account.status === 'in_app' && account.has_active_transfers"
        [class.account-resting]="!account.error_message && account.status === 'resting'">

        <!-- Custom content structure to bypass div restrictions -->
        <div class="account-item-content">
            @if (account.error_message) {
            <mat-icon color="warn">error</mat-icon>
            }

            <a class="account-name" (click)="showAccountInfo(account)">
                {{ account.name }}
            </a>

            @if (account.status == 'completed') {
            <button matButton="outlined" class="credit" (click)="loadAccountInfo(account)"
                [disabled]="account.creditLoading" [class.credit-failed]="account.creditFailed"
                matTooltip="Click to load credit">
                @if (account.creditLoading) {
                <mat-spinner diameter="16"></mat-spinner>
                } @else if (account.creditFailed) {
                <ng-container><mat-icon>error_outline</mat-icon> Retry</ng-container>
                } @else if (account.current_credit) {
                {{ account.current_credit / 1000 | number }}K
                @if (type == 'stock') {
                ({{ suggestedAmount(account.current_credit) | number }})
                }
                } @else {
                Load Credits
                }
            </button>
            } @else {
            <div class="account-status">
                <span [class]="'status-badge status-' + account.status"
                    [matTooltip]="account.error_message ? 'Error: ' + account.error_message : ('Message: ' + account.message)">
                    {{ account.status || 'unknown' }} {{ account.page ? `- ${account.page}` : '' }}
                </span>
                <!-- @if (account.progress > 0 && account.progress != 100) {
                <span class="progress-text">
                    {{ account.progress }}%
                </span>
                } -->
            </div>
            }

            <span class="spacer"></span>

            <button matMiniFab="outlined" [matMenuTriggerFor]="menu" aria-label="Account actions">
                <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="showAccountInfo(account)">
                    <mat-icon>info</mat-icon>
                    <span>View Info</span>
                </button>

                <button mat-menu-item (click)="showPlayers(account)">
                    <mat-icon>sports_soccer</mat-icon>
                    <span>View Players</span>
                </button>

                <button mat-menu-item (click)="renameAccount(account)">
                    <mat-icon>edit</mat-icon>
                    <span>Rename</span>
                </button>

                <button mat-menu-item (click)="ensureSidValidation(account)">
                    <mat-icon>replay</mat-icon>
                    <span>Ensure SID</span>
                </button>

                <button mat-menu-item (click)="reload(account)">
                    <mat-icon>replay</mat-icon>
                    <span>Reload</span>
                </button>

                <!-- <button mat-menu-item (click)="quickSellAll(account)" [disabled]="account.status !== 'in_app'">
                    <mat-icon>sell</mat-icon>
                    <span>Quick Sell All</span>
                </button> -->

                <button mat-menu-item (click)="clearExpiredItems(account)" [disabled]="account.status !== 'in_app'">
                    <mat-icon>auto_delete</mat-icon>
                    <span>Clear Expired Items</span>
                </button>

                <button mat-menu-item [matMenuTriggerFor]="screenshotMenu">
                    <mat-icon>screenshot</mat-icon>
                    <span>Get Screenshot</span>
                </button>

                <button mat-menu-item (click)="copy(account)">
                    <mat-icon>content_copy</mat-icon>
                    <span>Copy SID</span>
                </button>

                <button mat-menu-item (click)="logout(account)" class="delete-action">
                    <mat-icon color="warn">close</mat-icon>
                    <span>Close</span>
                </button>
            </mat-menu>

            <mat-menu #screenshotMenu="matMenu">
                <button mat-menu-item (click)="getScreenshot(account, 'current')">
                    <mat-icon>screenshot_frame</mat-icon>
                    <span>Default</span>
                </button>
                <button mat-menu-item (click)="getScreenshot(account, 'credit')">
                    <mat-icon>credit_card</mat-icon>
                    <span>Credit (Cropped)</span>
                </button>
                <button mat-menu-item (click)="getScreenshot(account, 'home')">
                    <mat-icon>home</mat-icon>
                    <span>Home Page</span>
                </button>
                <button mat-menu-item (click)="getScreenshot(account, 'transfer')">
                    <mat-icon>swap_horiz</mat-icon>
                    <span>Transfer Page</span>
                </button>
                <button mat-menu-item (click)="getScreenshot(account, 'setting')">
                    <mat-icon>settings_photo_camera</mat-icon>
                    <span>Settings Page</span>
                </button>
            </mat-menu>
        </div>
    </div>
    }
</mat-nav-list>
}